import { FormControlOptions } from '@miq/catalog';

/**
 * This file depicts the shape of a "Property" form. it includes and configures inputs in controlConfigs
 * attribute that are not part of the catalog but that are essential for a form to have as hidden field
 * or values, usually id controls or hidden/missing columns
 *
 * Since we rely entirely on catalog to "generate" form and control options on each level, few attributes
 * are not provided in the catalog but needs to be present as explained above. Therefore this file works
 * as a skeleton form control options for those essential attributes that are not part of the catalog
 */
export const CompanyFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  colloquial: {
    name: 'colloquial',
    type: 'array',
    controlsConfig: {
      id: [null],
      _mode: [null],
      country_code_desc: [null],
      language_desc: [null],
    },
  },
  company_industry_classification: {
    type: 'array',
    name: 'company_industry_classification',
    controlsConfig: {
      id: [null],
      primary_naics_code_f: [null],
      ref_naics_classification_desc: [null],
      ref_cbre_industry_code_desc: [null],
    },
  },
  phone: {
    type: 'array',
    name: 'phone',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  digital: {
    type: 'array',
    name: 'digital',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  location: {
    type: 'array',
    name: 'location',

    controlsConfig: {
      id: [null],
      location_id: [null],
      expiry_date: [null],
      _mode: [null],
    },

    children: {
      colloquial: {
        name: 'colloquial',
        type: 'array',
        controlsConfig: { id: [null], language_desc: [], country_code_desc: [] },
      },
      postal_address: {
        name: 'postal_address',
        type: 'group',
        children: {
          colloquial: {
            name: 'colloquial',
            type: 'array',
            controlsConfig: { id: [null], language_desc: [], country_code_desc: [] },
          },
        },
      },

      phone: {
        name: 'phone',
        type: 'array',
        controlsConfig: { id: [null] },
      },
    },
  },
});
